var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.comments),function(comment,index){return _c('div',{key:index},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm._f("moment")(comment.date,'DD/MM/YYYY'))+" - "+_vm._s(comment.author))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(comment.content))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-941a9ece","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Home/comments.vue
// module id = Ivi7
// module chunks = 1